import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import {store, key} from "@/components/auth/store";
import 'flowbite';
import VueNumberFormat from 'vue-number-format'


createApp(App)
    .use(router)
    .use(store, key)
    .use(VueNumberFormat, 
        {   
            decimal: '.', 
            thousand: ',',
            separator: ',',
            prefix: '$',
            suffix: '',
            precision: 2,
            masked: false 
        }
    )
    .mount("#app");
